/* eslint-disable react/forbid-prop-types */

import { useState, useEffect } from 'react'
import { instanceOf, string, object } from 'prop-types'

import { supportedLanguagesMediaUploader } from '../../utilities/constants.js'
import MediaUploaderIframe from './MediaUploaderIframe/MediaUploaderIframe.js'
import Locale from '../../../models/Locale.js'
import Icon from '../icon/index.js'

const TYPE_ALIGNS = {
  right: 'flex-end',
  left: 'flex-start',
  center: 'center',
}

const MediaUploader = ({ feedKey, locale, mediaUploaderSettings }) => {
  const {
    align_button: alignButton,
    text_color: textColor,
    terms_and_conditions_url: termsAndConditionsUrl,
    button_color: buttonColor,
    rounding,
    button_text: buttonText = locale.getTranslation('uploadYourMedia'),
  } = mediaUploaderSettings?.styling
    ? {
        ...mediaUploaderSettings?.styling,
        terms_and_conditions_url: mediaUploaderSettings?.terms_and_conditions_url,
      }
    : mediaUploaderSettings

  const isLocaleSupported = supportedLanguagesMediaUploader.includes(locale.language)

  const defaultLanguage = mediaUploaderSettings?.default_language || locale.language

  const [enableIframe, setEnableIframe] = useState(false)

  useEffect(() => {
    if (enableIframe) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }

    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [enableIframe])

  return (
    <div data-testid="media-uploader" style={{ alignSelf: TYPE_ALIGNS[alignButton] }}>
      <button
        className="bzfy-o-media-uploader-button"
        onClick={() => setEnableIframe(true)}
        style={{
          backgroundColor: buttonColor,
          borderRadius: `${rounding}px`,
          color: textColor,
        }}
        type="button"
      >
        <Icon color={textColor} icon="submit" />
        <span>{buttonText}</span>
      </button>
      {enableIframe && (
        <MediaUploaderIframe
          feedKey={feedKey}
          handleCloseClick={() => setEnableIframe(false)}
          language={!isLocaleSupported ? defaultLanguage : locale.language}
          settings={mediaUploaderSettings}
          termsAndConditionsURL={termsAndConditionsUrl}
        />
      )}
    </div>
  )
}

MediaUploader.propTypes = {
  feedKey: string.isRequired,
  locale: instanceOf(Locale).isRequired,
  mediaUploaderSettings: object.isRequired,
}
export default MediaUploader
